import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class PasswordChange extends Component {
    constructor(props) {
        super(props); console.log(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        all_server: [],
            this.state = {
                message: '',
                apiUrl: this.decryptconfigdata('apiUrl'),
                userId: has_local_data ? localdata.user_id : '',
                userName: has_local_data ? localdata.user_name : '',
                userAuthKey: has_local_data ? localdata.user_key : '',
                studioUrl: this.decryptconfigdata('studioUrl'),
                resel_customer: [],
                activePage: 1,
                item_count: '',
                item_count: '',
                partdetails: '',
                server_id: '',
                select_value_id: '',
                studio_id: '',
                user_details: '',
                errorMsg: '',
                selectedUserId: '',
                user_type: '',
                password: '',
                encrypted_password: '',
                fetchUrl: props.location.pathname,
                updated_password_value: '',
                password_field_value: ''
            }
        this.dataValue = '';
        this.handlePageChange = this.handlePageChange.bind(this);
        this.openEmailId = this.openEmailId.bind(this);
        this.handleSubmitForm = this.handleSubmitForm.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;

    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    componentDidMount(props) {
        this.getAllServerDetails();
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
    }
    //  back(id){
    //     window.location.href='/viewTicket/'+id;

    // }
    handlePageChange(event) {
        this.setState({ server_id: event.target.value });
        this.getAllServerDetails(event.target.value);
    }
    openEmailId(event) {
        this.setState({ studio_id: event.target.value });
        $('#form_email_').removeClass('hide');
    }
    onChange(propertyName, event) {
        this.setState({ [propertyName]: event.target.value });
        if (this.state.updated_password_value != '' && this.state.updated_password_value != null) {
            this.setState({ password: '' });
            $('.password_error').html('Please restore the password. Then only password changes can be done');
        } else {
            $('.password_error').html(''); 
        }
    }
    handleSubmitForm(clickEvent, event) {
        // console.log(event.target.value);
        // console.log(clickEvent);
        // console.log(localStorage.getItem('userName'));
      
        if (clickEvent == 'fetch') {
            this.dataType = '&user_email=' + this.state.email;
        } else if (clickEvent == 'update') {
            this.dataType = '&user_id=' + this.state.selectedUserId + '&new_password=' + this.state.password + '&changed_by=' + localStorage.getItem('userName') + '&encrypted_password=' + this.state.encrypted_password;
        } else if (clickEvent == 'restore') {
            this.dataType = '&user_id=' + this.state.selectedUserId;
        }
        this.dataType = this.dataType + '&user_type=' + this.state.user_type;
        // console.log(this.dataType);
        // //e.preventDefault();
        // console.log("EMail: " + this.state.email);
        // console.log(this.state);
        fetch(this.state.apiUrl + '/customersuccess/getuserdetails/?server_id=' + this.state.server_id + '&isReact=1&action=' + clickEvent + '&studio_id=' + this.state.studio_id + this.dataType, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        }).then((Response2) => Response2.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.msg) {
                    alert(findresponse.msg);
                    $('.title').removeClass('hide');
                }
                if (findresponse.status == 'success') {
                    $('.title').removeClass('hide');
                    if (findresponse.changed_password != null) {
                        this.setState({
                            updated_password_value: findresponse.changed_password
                        });
                        this.setState({
                            password: ''
                        });
                    }
                    

                }
                if (findresponse.message) {
                    this.state.password = '';
                }
               
                
                (findresponse.status == 'failure') ? this.state.email = ''
                    : (findresponse.message) ?
                        alert(findresponse.message)
                        :
                        (findresponse.status == 'success') ?
                            this.setState({
                                user_details: findresponse.details,
                                selectedUserId: findresponse.details.id,
                                encrypted_password: findresponse.details.encrypted_password
                            }) :
                            alert(findresponse.msg)
                this.setState({
                    errorMsg: findresponse.msg
                });



            })
    }

    getAllServerDetails(select_value_id) {

        fetch(this.state.apiUrl + '/customersuccess/PasswordChange/isReact/1/server_id/' + select_value_id, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                (findresponse.all_servers) ?
                    this.setState({
                        all_server: findresponse.all_servers,
                    }) :
                    this.setState({
                        all_customers: findresponse.all_customers,
                    })

            })
    }

    // handleEmailChange(event) {
    //     this.setState({ email: event.target.value });
    // }

    // getAllServerDetails() {
    //     fetch(this.state.apiUrl + '/customerSuccess/PasswordChange/isReact=1', )
    //         .then((Response) => Response.json())
    //         .then((responseJson) => {
    //            console.log('hioi'); 

    //         })
    // }
    getServerDetails() {
        return (
            <div class="row">
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.handlePageChange}>
                            <option value="" >Please selct server</option>
                            {
                                (this.state.all_server) ? this.state.all_server.map((severData, key) =>
                                    <option value={severData.id}>{severData.customer_name}</option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.openEmailId}>
                            <option value="" >Please selct customer</option>
                            {
                                (this.state.all_customers) ? this.state.all_customers.map((severData, key) =>
                                    <option value={severData.id}>{severData.name} - {severData.domain} </option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                {
                    (this.state.studio_id) ?
                        <div class="col-md-12 form-group ">
                            <div class="filter">
                                <select class="form-control" id="select_value" name="savedFilter" onChange={this.onChange.bind(this, 'user_type')} >
                                    <option value="" >Please selct type</option>
                                    <option value="0">Admin user</option>
                                    <option value="1">End user</option>
                                </select>
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                        : ''
                }
            </div>
        )
    }
    getFormDetails() {
        return (
            (this.state.user_type) ?
                <form class="top-row-form" id="form_email_">
                    <div class="form-group">
                        <label for="title">Email</label>
                        <div class="candidate_details_des">
                            <input type="text" class="form-control" value={this.state.email} onChange={this.onChange.bind(this, 'email')} />
                        </div>
                    </div>
                    <input type="button" class="btn btn-sky" value="Submit" data-type="fetch" onClick={this.handleSubmitForm.bind(this, 'fetch')} />
                </form> : ''
        )
    }
    getUserDetails() {
        return (
    
            <div class="title hide">
                {
                    (this.state.user_details) ?
                        <div>
                            <span class="job_title">User Details</span>
                            <div class="row intra_form">
                                <div class="col-md-6 col-xs-12">
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-xs-5 col-form-label">Name:</label>
                                        <div class="col-sm-9 col-xs-7">
                                            <span class="con_old_fields">{this.state.user_details.display_name}</span>
                                        </div>
                                    </div>
                                </div>
                                {
                                    (this.state.updated_password_value) ?
                                    <div class="col-md-6 col-xs-12">
                                        <div class="form-group row">
                                            <label class="col-sm-3 col-xs-5 col-form-label">Changed password:</label>
                                            <div class="col-sm-9 col-xs-7">
                                                <span class="con_old_fields">{this.state.updated_password_value}</span>
                                            </div>
                                        </div>
                                    </div> : ''
                                }
                               
                                <div class="col-md-6 col-xs-12">
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-xs-5 col-form-label">Email:</label>
                                        <div class="col-sm-9 col-xs-7">
                                            <span class="con_old_fields">{this.state.user_details.email}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xs-12">
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-xs-5 col-form-label">Password:</label>
                                        <div class="col-sm-9 col-xs-7">
                                            <input type="text" id="new_password" name="new_password" class="form-control new_password" value={this.state.password} onChange={this.onChange.bind(this, 'password')} />
                                        <span class="error password_error"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-muvi">
                                    <a class="btn btn-sky update_password" disabled={!this.state.password} href="#" data-toggle="collapse" onClick={(this.state.password) ? this.handleSubmitForm.bind(this, 'update') : 'return false;'} >Update password</a>
                                    <button class="btn btn-blue" onClick={this.handleSubmitForm.bind(this, 'restore')} >Restore</button>
                                </div>

                            </div>
                        </div> : ''
                }
            </div>
        )
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />

            )
        }
        return (
            <div>
                <Header brecum_name="partners" brecum_page="Password change" />
                <div class="right_col">
                    <section class="intranet_body">
                        {this.getServerDetails()}
                        {this.getFormDetails()}
                        {this.getUserDetails()}



                        {/* {this.getNoofcustomer()} */}

                        {/* <div class="pagination-muvi">
         <Pagination
          activePage={this.state.activePage}
          itemsCountPerPage={10}
          totalItemsCount={this.state.item_count}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
        </div> */}
                    </section>
                </div>
            </div>
        )
    }
}
class FcmChange extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        all_server: [],
            this.state = {
                message: '',
                apiUrl: this.decryptconfigdata('apiUrl'),
                userId: has_local_data ? localdata.user_id : '',
                userName: has_local_data ? localdata.user_name : '',
                userAuthKey: has_local_data ? localdata.user_key : '',
                studioUrl: this.decryptconfigdata('studioUrl'),
                server_id: '',
                select_value_id: '',
                studio_id: '',
                device_type: '',
                fcm_type: '',
                fcm_key: ''
            }
        this.dataValue = '';
        this.handlePageChange = this.handlePageChange.bind(this);
        //     this.openEmailId = this.openEmailId.bind(this);
        //    // this.handleEmailChange = this.handleEmailChange.bind(this);
        //     this.handleSubmitForm = this.handleSubmitForm.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;

    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    componentDidMount(props) {
        console.log('page load2');
        this.getAllServerDetails();
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
    }
    handlePageChange(event) {
        this.setState({ server_id: event.target.value });
        this.getAllServerDetails(event.target.value);
    }
    onChange(propertyName, event) {
        this.setState({ [propertyName]: event.target.value });
        console.log(this.state.device_type)
    }
    getAllServerDetails(select_value_id) {

        fetch(this.state.apiUrl + '/customersuccess/fcmkeyupdate/isReact/1/server_id/' + select_value_id, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                (findresponse.all_servers) ?
                    this.setState({
                        all_server: findresponse.all_servers,
                    }) :
                    this.setState({
                        all_customers: findresponse.all_customers,
                    })

            })
    }
    fetChDetails(clickEvent, action, event) {
        // console.log(event.target.value);
        // console.log(clickEvent);
        (clickEvent != '') ? this.onChange(clickEvent, event) : '';
        (action == 'update') ? this.device_type = this.state.device_type : (clickEvent != '') ? this.device_type = event.target.value : this.device_type = this.state.device_type;
        
       // (this.state.device_type) ?  this.setState.device_type = event.target.value : '';
        //this.device_type = (this.state.device_type) ? this.state.device_type :event.target.value;
        this.dataType = '';
        (this.state.fcm_key_new && action == 'update') ? this.dataType = '&fcm_value=' + this.state.fcm_key_new : '';
        fetch(this.state.apiUrl + '/customersuccess/fcmkeyupdate?isReact=1&action=' + action + '&server_id=' + this.state.server_id + '&studio_id=' + this.state.studio_id + '&device_type=' + this.device_type + this.dataType, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
               (findresponse.type) ? 
                this.setState({
                    fcm_type: findresponse.type,
                    fcm_key: findresponse.fcm_key,
                    }) : ''
                if (findresponse.message) {
                  alert(findresponse.message);
                  this.setState({
                        fcm_key_new: ''
                  }) 
                    this.fetChDetails('', 'fetch');
               }
            })
    }
    getServerDetails() {
        return (
            <div class="row">
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.handlePageChange}>
                            <option value="" >Please selct server</option>
                            {
                                (this.state.all_server) ? this.state.all_server.map((severData, key) =>
                                    <option value={severData.id}>{severData.customer_name}</option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.onChange.bind(this, 'studio_id')}>
                            <option value="" >Please selct customer</option>
                            {
                                (this.state.all_customers) ? this.state.all_customers.map((severData, key) =>
                                    <option value={severData.id}>{severData.name} - {severData.domain} </option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                {
                    (this.state.studio_id) ?
                        <div class="col-md-12 form-group ">
                            <div class="filter">
                                <select class="form-control" id="select_value" name="savedFilter" onChange={this.fetChDetails.bind(this, 'device_type', 'fetch')} >
                                    <option value="" >Please selct type</option>
                                    <option value="1">Android</option>
                                    <option value="2">Ios</option>
                                </select>
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                        : ''
                }
          
            </div>
        )
    }
    fcmFormFetch() {
        return (
            (this.state.fcm_type && this.state.fcm_key) ?
        <div class="title">
                <span class="job_title">Fcm details</span>
                <div class="row intra_form">
                    <div class="col-md-12 col-xs-12">
                        <div class="form-group row">
                            <label class="col-sm-2 col-xs-5 col-form-label"><strong3>{this.state.fcm_type} :</strong3> </label>
                            <div class="col-sm-11 col-xs-7">
                                <span class="con_old_fields">{this.state.fcm_key}</span>
                            </div>
                        </div>
                    </div>
                  
                    <div class="col-md-12 col-xs-12">
                        <div class="form-group row">
                            <label class="col-sm-2 col-xs-5 col-form-label">New Fcm Key:</label>
                                <div class="col-sm-9 col-xs-7" style={{ marginLeft: '-1.5%', width: '68%' }}>
                                <input type="text" id="new_fcm_key" name="new_fcm_key" class="form-control new_fcm_key" value={this.state.fcm_key_new} onChange={this.onChange.bind(this, 'fcm_key_new')} />
                            </div>
                        </div>
                    </div>
                    <div class="btn-muvi">
                            <a class="btn btn-sky update_password" disabled={!this.state.fcm_key_new} href="javascript:void(0)" data-toggle="collapse" onClick={this.fetChDetails.bind(this, this.state.device_type, 'update')} >Update fcm key</a>
                    </div>

                </div>
        </div>
        : ''
        )
        
    }
    render() {

        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />

            )
        }
        return (
            <div>
                <Header brecum_name="Customer Success" brecum_page="Fcm Change" />
                <div class="right_col">
                    <section class="intranet_body">
                        {this.getServerDetails()}
                        {this.fcmFormFetch()}
                    </section>
                </div>
            </div>
        )
    }
}
class DefaultPage extends Component {
    componentDidMount(props) {
        console.log('page load3');
    }
    render() {

        return (
            <div>
                <Header brecum_name="DefaultPage" brecum_page="DefaultPage" />
                <div class="right_col">
                    <div class="coming_soon"><div class="coming_soon_text">Coming Soon Default page</div></div>
                </div>
            </div>
        )
    }
}
class StorebillingdateChange extends Component {
    constructor(props) {
        super(props); console.log(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        all_server: [],
            this.state = {
                message: '',
                apiUrl: this.decryptconfigdata('apiUrl'),
                userId: has_local_data ? localdata.user_id : '',
                userName: has_local_data ? localdata.user_name : '',
                userAuthKey: has_local_data ? localdata.user_key : '',
                studioUrl: this.decryptconfigdata('studioUrl'),
                resel_customer: [],
                activePage: 1,
                item_count: '',
                item_count: '',
                partdetails: '',
                server_id: '',
                select_value_id: '',
                studio_id: '',
                user_details: '',
                errorMsg: '',
                selectedUserId: '',
                user_type: '',
                password: '',
                encrypted_password: '',
                fetchUrl: props.location.pathname,
                updated_password_value: '',
                password_field_value: ''
            }
        this.dataValue = '';
        this.handlePageChange = this.handlePageChange.bind(this);
        this.openEmailId = this.openEmailId.bind(this);
        // this.handleEmailChange = this.handleEmailChange.bind(this);
        this.updateStoreBilling = this.updateStoreBilling.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;

    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    componentDidMount(props) {
        this.getAllServerDetails();
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
    }
    //  back(id){
    //     window.location.href='/viewTicket/'+id;

    // }
    handlePageChange(event) {
        this.setState({ server_id: event.target.value });
        this.getAllServerDetails(event.target.value);
    }
    openEmailId(event) {
        this.setState({ studio_id: event.target.value });
        $('#form_email_').removeClass('hide');
    }
	onChange(propertyName, event) {
		 this.setState({ [propertyName]: event.target.value });
        if (propertyName == 'user_type' || (propertyName == 'studio_id' && this.state.studio_dates != '')) {
			this.getDetails(propertyName, event)
		};
	}
    getDetails(propertyName, event) {
		this.studio_id = (this.studio_id != event.target.value && propertyName == 'studio_id') ? event.target.value : this.state.studio_id;
		console.log(this.studio_id);
        fetch(this.state.apiUrl + '/customersuccess/getCustomerDetails/isReact/1/server_id/' + this.state.server_id + '/studio_id/' + this.studio_id + '/storebillingdatechange/1', {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        }).then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
				 (findresponse.studio_dates_data) ? 
				 	this.setState({
                        studio_dates: findresponse.studio_dates_data[0]
								})
				 : ''
                    

            })
    }
    updateStoreBilling(clickEvent, action, event) {
       
        //if (clickEvent == 'fetch') {
//            this.dataType = '&user_email=' + this.state.email;
//        } else if (clickEvent == 'update') {
//            this.dataType = '&user_id=' + this.state.selectedUserId + '&new_password=' + this.state.password + '&changed_by=' + localStorage.getItem('userName') + '&encrypted_password=' + this.state.encrypted_password;
//        } else if(clickEvent == 'restore'){
//            this.dataType = '&user_id=' + this.state.selectedUserId ;
//        }
        //this.dataType = this.dataType + '&user_type=' + this.state.user_type;
	
        // //e.preventDefault();
        // console.log("EMail: " + this.state.email);
        // console.log(this.state);
        fetch(this.state.apiUrl + '/customersuccess/updateStoreBillingDate?server_id=' + this.state.server_id + '&isReact=1&studio_id=' + this.state.studio_id + '&start_date='+ this.state.studio_dates.start_date +'&end_date='+ this.state.studio_dates.end_date +'&bandwidth_date='+this.state.studio_dates.bandwidth_date+'&check_user_type='+this.state.user_type+'&partial_failed_date='+this.state.studio_dates.partial_failed_date+'&partial_failed_due='+this.state.studio_dates.partial_failed_due, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        }).then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
				 (findresponse.status == 'success') ?
                            alert(findresponse.msg) : ''
                          
                    

            })
    }

    getAllServerDetails(select_value_id) {

        fetch(this.state.apiUrl + '/customersuccess/PasswordChange/isReact/1/server_id/' + select_value_id, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                (findresponse.all_servers) ?
                    this.setState({
                        all_server: findresponse.all_servers,
                    }) :
                    this.setState({
                        all_customers: findresponse.all_customers,
                    })

            })
    }

    // handleEmailChange(event) {
    //     this.setState({ email: event.target.value });
    // }

    // getAllServerDetails() {
    //     fetch(this.state.apiUrl + '/customerSuccess/PasswordChange/isReact=1', )
    //         .then((Response) => Response.json())
    //         .then((responseJson) => {
    //            console.log('hioi'); 

    //         })
    // }
    onChangeowner(propertyName, event) {
    const studio_dates = this.state.studio_dates;
    studio_dates[propertyName] = event.target.value;
    this.setState({ studio_dates: studio_dates });
  }
    getServerDetails() {
        return (
            <div class="row">
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.handlePageChange}>
                            <option value="" >Please selct server</option>
                            {
                                (this.state.all_server) ? this.state.all_server.map((severData, key) =>
                                    <option value={severData.id}>{severData.customer_name}</option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.onChange.bind(this, 'studio_id')}>
                            <option value="" >Please selct customer</option>
                            {
                                (this.state.all_customers) ? this.state.all_customers.map((severData, key) =>
                                    <option value={severData.id}>{severData.name} - {severData.domain} </option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                {
                    (this.state.studio_id) ?
                        <div class="col-md-12 form-group ">
                            <div class="filter">
                                <select class="form-control" id="select_value" name="savedFilter" onChange={this.onChange.bind(this, 'user_type')} >
                                    <option value="">Please select user type</option>
                                    <option value="0">Billing Date Change</option>
                                    <option value="1">Unblock Store & Billing date Change</option>
									<option value="2">Cancelled Store unblock with Billing date Change</option>
                                </select>
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                        : ''
                }
            </div>
        )
    }
    getFormDetails() {
        return (
            (this.state.user_type && this.state.user_type!=3) ?
				<div class="row " id="type_user1">
                <div class="col-md-12 form-group" >
                <label class="col-md-3">Next Billing Date</label>
                <div class="col-md-9" >
                            <input required type="text" name="config_key" id="next_billing_date" class="form-control email_value" value={this.state.studio_dates.start_date} onChange={this.onChangeowner.bind(this, 'start_date')} placeholder="yyyy-mm-dd" />
                </div>
                </div>
                <div class="col-md-12 form-group">
                 <label class="col-md-3">Next Billing End Date</label>
                <div class="col-md-9" >
                            <input required type="text" name="config_key" id="next_billing_end_date" class="form-control email_value" value={this.state.studio_dates.end_date} onChange={this.onChangeowner.bind(this, 'end_date')} placeholder="yyyy-mm-dd" />
                </div>
                </div>
                 <div class="col-md-12 form-group">
                <label class="col-md-3">Next Billing Bandwidth Date</label>
                <div class="col-md-9" >
                            <input required type="text" name="config_key" id="next_billing_bandwidth_date" class="form-control email_value" value={this.state.studio_dates.bandwidth_date} onChange={this.onChangeowner.bind(this, 'bandwidth_date')} placeholder="yyyy-mm-dd" />

                </div>
                </div>
                    <div class="col-md-12 form-group">
                        <div class="col-md-4"></div>
                        
                        <div class="col-md-4"> 
                            <button type="button" class="action-btn form-control btn btn-primary reset_demo" onClick={this.updateStoreBilling.bind(this, this.state.device_type, 'update')}>Submit</button>
                        </div> 
                    </div> 
                </div>
				
                    
              : ''
        )
    }
   
    getFormDetailsBlock() {
        return (
            (this.state.user_type==3) ?
				<div class="row " id="type_user1">
                <div class="col-md-12 form-group" >
                <label class="col-md-3">Payment Failure Date</label>
                <div class="col-md-9" >
                <input required type="text"  name="partial_failed_date" id="partial_failed_date" class="form-control email_value" value={this.state.studio_dates.partial_failed_date} onChange={this.onChangeowner.bind(this,'partial_failed_date')} placeholder="yyyy-mm-dd"/>
                </div>
                </div>
                <div class="col-md-12 form-group" >
                <label class="col-md-3">Payment Due</label>
                <div class="col-md-9" >
                <input required type="text"  name="partial_failed_due" id="partial_failed_due" class="form-control email_value" value={this.state.studio_dates.partial_failed_due} onChange={this.onChangeowner.bind(this,'partial_failed_due')} placeholder="Please Enter amount Or Leave Blank"/>
                </div>
                </div>
                    <div class="col-md-12 form-group">
                        <div class="col-md-4"></div>
                        
                        <div class="col-md-4"> 
                            <button type="button" class="action-btn form-control btn btn-primary reset_demo" onClick={this.updateStoreBilling.bind(this,this.state.device_type, 'update')}>Submit</button>
                        </div> 
                    </div> 
                </div>
				
                    
              : ''
        )
    }
   
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />

            )
        }
        return (
            <div>
                <Header brecum_name="partners" brecum_page="Store Billing Date Change,Unblock store,Block store" />
                <div class="right_col">
                    <section class="intranet_body">
                        {this.getServerDetails()}
                        {this.getFormDetails()}
                       {this.getFormDetailsBlock()}
                       

                        {/* {this.getNoofcustomer()} */}

                        {/* <div class="pagination-muvi">
         <Pagination
          activePage={this.state.activePage}
          itemsCountPerPage={10}
          totalItemsCount={this.state.item_count}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
        </div> */}
                    </section>
                </div>
            </div>
        )
    }
}

class UserinfoRemove extends Component {
    constructor(props) {
        super(props); console.log(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        all_server: [],
            this.state = {
                message: '',
                apiUrl: this.decryptconfigdata('apiUrl'),
                userId: has_local_data ? localdata.user_id : '',
                userName: has_local_data ? localdata.user_name : '',
                userAuthKey: has_local_data ? localdata.user_key : '',
                studioUrl: this.decryptconfigdata('studioUrl'),
                resel_customer: [],
                activePage: 1,
                item_count: '',
                item_count: '',
                partdetails: '',
                server_id: '',
                select_value_id: '',
                studio_id: '',
                user_details: '',
                errorMsg: '',
                selectedUserId: '',
                user_type: '',
                password: '',
                encrypted_password: '',
                fetchUrl: props.location.pathname,
                updated_password_value: '',
                password_field_value: ''
            }
        this.dataValue = '';
        this.handlePageChange = this.handlePageChange.bind(this);
        this.openEmailId = this.openEmailId.bind(this);
        // this.handleEmailChange = this.handleEmailChange.bind(this);
        this.updateStoreBilling = this.updateStoreBilling.bind(this);
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;

    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    componentDidMount(props) {
        this.getAllServerDetails();
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
    }
    //  back(id){
    //     window.location.href='/viewTicket/'+id;

    // }
    handlePageChange(event) {
        this.setState({ server_id: event.target.value });
        this.getAllServerDetails(event.target.value);
    }
    openEmailId(event) {
        this.setState({ studio_id: event.target.value });
        $('#form_email_').removeClass('hide');
    }
	onChange(propertyName, event) {
		 this.setState({ [propertyName]: event.target.value });
		
	}
    
    updateStoreBilling(clickEvent, action, event) {
       

        fetch(this.state.apiUrl + '/customersuccess/deleteUserInfo?server_id=' + this.state.server_id + '&isReact=1&studio_id=' + this.state.studio_id + '&user_email=' + this.state.email + '&user_type=' + this.state.user_type, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        }).then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
				 (findresponse.status == 'success') ?
                            alert(findresponse.msg) : ''
            })
    }

    getAllServerDetails(select_value_id) {

        fetch(this.state.apiUrl + '/customersuccess/PasswordChange/isReact/1/server_id/' + select_value_id, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                (findresponse.all_servers) ?
                    this.setState({
                        all_server: findresponse.all_servers,
                    }) :
                    this.setState({
                        all_customers: findresponse.all_customers,
                    })

            })
    }

    // handleEmailChange(event) {
    //     this.setState({ email: event.target.value });
    // }

    // getAllServerDetails() {
    //     fetch(this.state.apiUrl + '/customerSuccess/PasswordChange/isReact=1', )
    //         .then((Response) => Response.json())
    //         .then((responseJson) => {
    //            console.log('hioi'); 

    //         })
    // }
	
  
   onChangeowner(propertyName, event) {
        this.setState({ [propertyName]: event.target.value });
    }
    getServerDetails() {
        return (
            <div class="row">
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.handlePageChange}>
                            <option value="" >Please selct server</option>
                            {
                                (this.state.all_server) ? this.state.all_server.map((severData, key) =>
                                    <option value={severData.id}>{severData.customer_name}</option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="col-md-12 form-group ">
                    <div class="filter">
                        <select class="form-control" id="select_value" name="savedFilter" onChange={this.onChange.bind(this, 'studio_id')}>
                            <option value="" >Please selct customer</option>
                            {
                                (this.state.all_customers) ? this.state.all_customers.map((severData, key) =>
                                    <option value={severData.id}>{severData.name} - {severData.domain} </option>
                                ) : ''
                            }
                        </select>
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
                {
                    (this.state.studio_id) ?
                        <div class="col-md-12 form-group ">
                            <div class="filter">
                                <select class="form-control" id="select_value" name="savedFilter" onChange={this.onChange.bind(this, 'user_type')} >
                                    <option value="">Please select user type</option>
                                    <option value="0">Card Informations remove</option>
                                    <option value="1">All Info Remove</option>
                                </select>
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </div>
                        </div>
                        : ''
                }
            </div>
        )
    }
    getFormDetails() {
        return (
            (this.state.user_type) ?
				<div class="row " id="type_user1">
                <div class="col-md-12 form-group" >
                <label class="col-md-3">User Email ID</label>
                <div class="col-md-9" >
                            <input required type="text" name="config_key" id="next_billing_date" class="form-control email_value" value={this.state.email} onChange={this.onChangeowner.bind(this, 'email')} placeholder="Please Enter email" />
                </div>
                </div>
                
                 
                    <div class="row">
                        <div class="col-md-4"></div>
                        
                        <div class="col-md-4"> 
                            <button type="button" class="action-btn form-control btn btn-primary reset_demo" onClick={this.updateStoreBilling.bind(this, this.state.device_type, 'update')}>Submit</button>
                        </div> 
                    </div> 
                </div>
				
                    
              : ''
        )
    }
   
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />

            )
        }
        return (
            <div>
                <Header brecum_name="partners" brecum_page="User Info Delete" />
                <div class="right_col">
                    <section class="intranet_body">
                        {this.getServerDetails()}
                        {this.getFormDetails()}
                       


                        {/* {this.getNoofcustomer()} */}

                        {/* <div class="pagination-muvi">
         <Pagination
          activePage={this.state.activePage}
          itemsCountPerPage={10}
          totalItemsCount={this.state.item_count}
          pageRangeDisplayed={5}
          onChange={this.handlePageChange}
        />
        </div> */}
                    </section>
                </div>
            </div>
        )
    }
}

export {
    FcmChange,
    DefaultPage,
    PasswordChange,
	StorebillingdateChange,
	UserinfoRemove,
}


// WEBPACK FOOTER //
// ./src/components/customerSuccess/customerSuccess.js